import { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { userSlice } from '@wellesley/user/slices/userSlice'
import { authSlice } from '../../authSlice'
import { useAppsNavigate } from '@wellesley/router'
import { AppsRoutes, getRoute } from '@wellesley/router/getRoute'
import { getUserNameWithDomain } from 'helpers/getUserNameWithDomain'

export const useAuthRedirect = () => {
  const navigate = useAppsNavigate()
  const isLogged = useSelector(authSlice.selectors.selectIsAuthenticated)

  const [params] = useSearchParams()
  const redirectUrlFromParam = params.get('redirectUrl')

  const user = useSelector(userSlice.selectors.selectCurrentUser)
  const usernameUrl = user
    ? getRoute(`/@/:username`, { username: getUserNameWithDomain(user) })
    : ''

  const redirectUrl = redirectUrlFromParam || usernameUrl

  const redirect = useCallback(() => {
    if (redirectUrl && isLogged) navigate(redirectUrl as AppsRoutes)
  }, [isLogged, redirectUrl])

  return { redirect, redirectUrl, isLogged }
}

export const useRedirectAfterAuth = () => {
  const { redirect, isLogged, redirectUrl } = useAuthRedirect()
  useEffect(() => {
    if (redirectUrl && isLogged) redirect()
  }, [redirectUrl, isLogged])
}
